import React, { Component } from 'react';
import { Dimensions, BackHandler } from 'react-native';
import * as actions from 'actions';
import { isWeb, View, Animated, Easing } from 'core';
import { theme, css } from 'constants';

const styles = css({
  holder: {
    backgroundColor: theme.gray_color_alpha(0.4),
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    //justifyContent:'center',
    position: 'absolute',
    flex: 1
  },
  content: {
    backgroundColor: 'white',
    minWidth: 600,
    minHeight: 500,
    marginTop: 150
  }
});
const dimensions = Dimensions.get('window');

const ModalWeb = ({ visible, children, onRequestClose, style }) =>
  visible ? (
    <View style={styles.holder}>
      <View style={[styles.content, style]}>{children}</View>
    </View>
  ) : null;

export class ModalNative extends Component {
  slide = new Animated.Value(0);
  state = {};
  componentDidMount() {
    this.props.visible && this.slideUp();
    this.props.visible && this.setState({ children: this.props.children });
  }

  componentDidUpdate(p) {
    const n = this.props;
    !p.visible && n.visible && this.slideUp();
    p.visible && !n.visible && this.slideDown();
    n.visible &&
      n.children !== p.children &&
      n.children &&
      (n.children.filter ? n.children.filter(e => e).length && this.setState({ children: n.children }) : this.setState({ children: n.children }));
  }
  _onRequestClose = () => {
    this.props.onRequestClose && this.props.onRequestClose();
    return true;
  };
  slideUp = () => {
    BackHandler.addEventListener('hardwareBackPress', this._onRequestClose);
    this.slide.setValue(0);
    Animated.timing(this.slide, {
      toValue: 1,
      duration: 300,
      useNativeDriver: true,
      easing: Easing.out(Easing.circle)
    }).start();
  };

  slideDown = () => {
    BackHandler.removeEventListener('hardwareBackPress', this._onRequestClose);
    if (this.props.animationType === 'none') {
      this.setState({ children: null });
      return;
    }
    this.slide.setValue(1);
    Animated.timing(this.slide, {
      toValue: 0,
      duration: 250,
      useNativeDriver: true,
      easing: Easing.in(Easing.circle)
    }).start(() => this.setState({ children: null }));
  };

  render() {
    const { transparent, animationType } = this.props;
    const { children } = this.state;
    const translate = {
      transform: [
        {
          translateY: this.slide.interpolate({
            inputRange: [0, 1],
            outputRange: [dimensions.height, 0]
          })
        }
      ]
    };
    const fade = { opacity: this.slide };
    const ani = animationType === 'none' ? {} : animationType === 'fade' ? fade : translate;
    return children ? (
      <Animated.View
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          backgroundColor: transparent ? 'rgba(0,0,0,0)' : 'white',
          ...ani
        }}
      >
        {children}
      </Animated.View>
    ) : null;
  }
}

export const Modal = isWeb ? ModalWeb : ModalNative;

export const ModalProvider = ({ Content, children }) => (
  <Modal transparent={false} visible={Content || children ? true : false} onRequestClose={actions.clickCloseModal}>
    {Content ? <Content /> : null}
    {children}
  </Modal>
);



// WEBPACK FOOTER //
// ./src/components/core/modal.js